import { NavLink } from "react-router-dom";

const ModuleSubNav = ({ tabs }) => {
  return (
    <div className="flex justify-end mb-6">

      <div className="bg-white border border-slate-200 rounded-2xl px-2 py-1 flex gap-2 shadow-sm">

        {tabs.map(tab => (
          <NavLink
            key={tab.name}
            to={tab.path}
            end={tab.end}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-2 text-sm font-semibold rounded-xl transition ${
                isActive
                  ? "bg-blue-950 text-white shadow"
                  : "text-slate-500 hover:text-blue-950"
              }`
            }
          >
            {tab.icon}
            {tab.name}
          </NavLink>
        ))}

      </div>
    </div>
  );
};

export default ModuleSubNav;
